import React from 'react';
import propTypes from 'prop-types';
import { ReactDataTable } from '@metarouter-private/mr-mui';
import assignedPipelinesTableColumns from './assignedPipelinesTableColumns';
import NoDataText from 'app/components/data-table/NoDataText';
import formatPlaybooksForTable from 'app/playbook-editor/overview/AssignedPipelinesTable/formatPlaybooksForTable';

function AssignedPipelinesTable({ playbooks }) {
  const tableData = formatPlaybooksForTable(playbooks);

  return (
    <ReactDataTable
      columns={assignedPipelinesTableColumns}
      data={tableData}
      noDataComponent={<NoDataText>No assigned pipelines</NoDataText>}
    />
  );
}

AssignedPipelinesTable.propTypes = {
  playbooks: propTypes.array.isRequired,
};

export default AssignedPipelinesTable;
